import styled from 'styled-components';
import { Box } from '../CommonComponents/OPL/Box/Box';

export const Wrapper = styled(Box)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
});
